import Controller from "./optionField.controller";
import template from "./optionField.html";

const optionField = {
  template,
  controller: Controller,
  bindings: {
    eventName: "<",
    permissionName: "@",
    optionTitle: "@",
    optionUnit: "@",
    optionObj: "<",
  },
};

export default optionField;



// WEBPACK FOOTER //
// ./src/components/optionField/optionField.component.js